<template>
  <section class="notice-container">
    <el-tabs
      v-model="merchant_platform"
      @tab-click="handleChangeTab"
    >
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :key="index"
        :label="tab.name"
        :name="String(tab.id)"
      ></el-tab-pane>
    </el-tabs>
    <template
      v-for="(item,index) in formList">
      <el-form
        :key="`item${index}`"
        :ref="`item${index}`"
        :rules="rules"
        :model="item">
        <div class="notice-list">
          <div
            class="flex flex-sb flex-inline">
            <div>
              <span
                v-if="index!=0"
                class="span-title">{{item.name}}</span>
              <div class="flex">
                <v-checkbox
                  v-model="item.is_enable"
                  @change="handleChange">Enable Notice</v-checkbox>
                <v-checkbox
                  v-model="item.closable"
                  @change="handleChange">Closable</v-checkbox>
              </div>
            </div>
            <div
              v-if="!isDisable(index)"
              class=" button-save"
              align="right">
              <v-button
                class="button"
                @click="handleCancel(index)"
              >Cancel</v-button>
              <v-button
                class="success"
                @click="submitForm(index)">Save</v-button>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Content (English)</span>
              <el-form-item
                :rules="rules.en_us"
                prop="content.en_us"
              >
                <v-input
                  v-model="item.content.en_us"
                  :index="index"
                  type="textarea"
                  :rows="4"
                  @change="handleChange"/>
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Content (Traditional Chinese)</span>
              <el-form-item
                :rules="rules.zh_hk"
                prop="content.zh_hk"
              >
                <v-input
                  v-model="item.content.zh_hk"
                  :index="index"
                  type="textarea"
                  :rows="4"
                  @change="handleChange"/>
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>URL(En)</span>
              <v-input
                v-model="item.link.en_us"
                :index="index"
                @change="handleChange"/>
            </div>
            <div class="form-item form-half">
              <span>URL</span>
              <v-input
                v-model="item.link.zh_hk"
                :index='index'
                @change="handleChange"/>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Auto-Disable Date</span>
              <v-date-picker
                v-model="item.expiry_date"
                @change="handleChange"/>
            </div>
          </div>

        </div>
      </el-form>
    </template>
  </section>
</template>

<script>
import {getNoticeDetail, modifyNotice} from '@/api/news'

export default {
  name: 'NoticeContainer',
  data() {
    return {
      merchant_platform:'1',
      tabList:[
        {
          id: 1,
          name: 'HoldCover',
        },
        {
          id: 2,
          name:'Fina'
        },
      ],
      rules: {
        zh_hk: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        en_us: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
      },
      noticeList:[],
      formList:[
        {
          content: {
            zh_hk: '',
            en_us: '',
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 0,
        },
        {
          content: {
            zh_hk: '',
            en_us: '',
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 0,
          name: 'Contact Us',
          path:'contact-us'
        },
        {
          content: {
            zh_hk: '',
            en_us: '',
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 14,
          name: 'Motorcycle'
        },
        {
          content: {
            zh_hk: '',
            en_us: '',
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 11,
          name: 'Private Car'
        },
        {
          content: {
            zh_hk: '',
            en_us: '',
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 12,
          name: 'Commercial Vehicle'
        },
        {
          content: {
            zh_hk: '',
            en_us: '',
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 27,
          name: 'Personal Accident'
        },
        {
          content: {
            zh_hk: '',
            en_us: '',
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 26,
          name: 'Home'
        },
        {
          content: {
            zh_hk: '',
            en_us: '',
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 29,
          name: 'Fire'
        },
        {
          content: {
            zh_hk: '',
            en_us: '',
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 21,
          name: 'Domestic Helper'
        },
        {
          content: {
            zh_hk: '',
            en_us: '',
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 23,
          name: 'Travel'
        },
        {
          content: {
            zh_hk: '',
            en_us: '',
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 25,
          name: 'Overseas Student'
        },
        {
          content: {
            zh_hk: '',
            en_us: '',
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 22,
          name: 'Working Holiday'
        },
        {
          content: {
            zh_hk: '',
            en_us: '',
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 24,
          name: 'Interior Decoration'
        },
      ],
      origin_form:[]
    }
  },
  computed:{
    isDisable(){
      return(index)=>{
        let list = this.origin_form
        let data = this.formList[index]
        let item = list.find(item=> item.class_id == data.class_id)
        let disable = true
        if(item){
          Object.keys(data).forEach(key=>{
            if(key=='content'){
              let {content} = data
              let orgin = item.content
              Object.keys(orgin).forEach(cont=>{
                if(orgin[cont]!=content[cont])
                  return  disable = false
              })
            }else
            {
              if(item[key]!=data[key])
                return  disable = false
            }
          })
        }
        return disable
      }
    }
  },
  created() {
    this.network().getNoticeDetail()
  },
  methods: {
    handleChangeTab(){
      let obj =[
        {
          content: {
            zh_hk: '',
            en_us: ''
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 0
        },
        {
          content: {
            zh_hk: '',
            en_us: ''
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 14,
          name: 'Motorcycle'
        },
        {
          content: {
            zh_hk: '',
            en_us: ''
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 11,
          name: 'Private Car'
        },
        {
          content: {
            zh_hk: '',
            en_us: ''
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 12,
          name: 'Commercial Vehicle'
        },
        {
          content: {
            zh_hk: '',
            en_us: ''
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 27,
          name: 'Personal Accident'
        },
        {
          content: {
            zh_hk: '',
            en_us: ''
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 26,
          name: 'Home'
        },
        {
          content: {
            zh_hk: '',
            en_us: ''
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 29,
          name: 'Fire'
        },
        {
          content: {
            zh_hk: '',
            en_us: ''
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 21,
          name: 'Domestic Helper'
        },
        {
          content: {
            zh_hk: '',
            en_us: ''
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 23,
          name: 'Travel'
        },
        {
          content: {
            zh_hk: '',
            en_us: ''
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 25,
          name: 'Overseas Student'
        },
        {
          content: {
            zh_hk: '',
            en_us: ''
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 22,
          name: 'Working Holiday'
        },
        {
          content: {
            zh_hk: '',
            en_us: ''
          },
          link: {
            zh_hk: '',
            en_us: ''
          },
          expiry_date: '',
          is_enable: 0,
          closable: 0,
          class_id: 24,
          name: 'Interior Decoration'
        },
      ]
      this.formList = JSON.parse(JSON.stringify(obj))
      this.network().getNoticeDetail()
    },
    handleChange(val,index){
      // if(this.formList[index]){
      //   this.$set(this.formList[index],'disable',false)
      // }
    },
    handleCancel(index){
      let list = JSON.parse(JSON.stringify(this.origin_form))
      let data = this.formList[index]
      let item = list.find(item=> item.class_id == data.class_id)
      if(item) {
        item.disable = true
        this.$set(this.formList,index,item)
        this.$refs[`item${index}`][0].resetFields()
      }
    },
    submitForm(index) {
      let params = this.formList[index]
      params.path = index==1?'contact-us':''
      params.merchant_platform = this.merchant_platform
      this.$refs[`item${index}`][0].validate(valid => {
        if(valid) {
          this.network().modifyNotice(params,index)
        }
      })
    },
    network() {
      return {
        getNoticeDetail: async () => {
          let params = {
            merchant_platform:this.merchant_platform
          }
          const { data } = await getNoticeDetail(params)
          this.formList= this.formList.reduce((result, item, index)=> {
            if(this.$refs[`item${index}`][0])
              this.$refs[`item${index}`][0].clearValidate()
            const classId = item.class_id
            let noticeItem = data.find(item=> item.class_id == classId)
            if(index==1)
              noticeItem = data.find(item=> item.class_id == classId&&item.path=='contact-us')
            if(noticeItem) {
              noticeItem.name=item.name
              item = noticeItem
            }
            result.push({...item,disable:true})
            return result
          }, [])
          this.noticeList =JSON.parse(JSON.stringify(data))
          this.origin_form =JSON.parse(JSON.stringify(this.formList))

        },
        modifyNotice: async (params,index) => {
          const { data } = await modifyNotice(params)
          this.$message({
            type: 'success',
            message: data.message_language
          })
          let detailList =JSON.parse(JSON.stringify(this.origin_form))
          this.$set(detailList,index,params)
          this.origin_form=JSON.parse(JSON.stringify(detailList))
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.notice-container {
    //width: 500px;
  .notice-list{
    padding: 30px 0px;
    .flex-inline{
      margin-bottom: 20px;
    }
    .span-title{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #24292E;
      margin-bottom: 30px;
      display: inline-block;
    }
    ::v-deep .el-checkbox{
      display: flex;
      align-items: center;
    }
    .margin-bottom{
      margin-bottom: 20px;
    }
    border-bottom: 1px solid #D1D5DA;
  }
  .button-save{
    //margin-top: 20px;
    .button{
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-sizing: border-box;
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
      border-radius: 6px;
    }
    .success{
      background: #2EA44F;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-sizing: border-box;
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
      border-radius: 6px;
      color: #FFFFFF;
      right: 0;
    }
  }
}
</style>
